import axios from '@/http/axios';

export default {
  fetch: (oid, config: any = {}) => {
    return axios.get(`/service-candidates/${oid}`, config);
  },
  fetchList: (config: any = {}) => {
    return axios.get(`/service-candidates/`, config);
  },
  pickup: (oid, config: any = {}) => {
    return axios.put(`/service-candidates/${oid}/pickup`, config);
  },
  comment: (oid, config: any = {}) => {
    return axios.put(`/service-candidates/${oid}/comment`, config);
  },
  complete: (oid, config: any = {}) => {
    return axios.put(`/service-candidates/${oid}/complete`, config);
  },
  businessMessage: (oid, config: any = {}) => {
    return axios.put(`/service-candidates/${oid}/business-message`, config);
  },
};
